import React from 'react';
import colors from 'src/style/colors';

const PlainLineSmall = ({ left = true, thin }) => {
  return (
    <div
      css={{
        width: thin ? 4 : 5,
        backgroundColor: colors.yellow,
        position: 'static',
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: left ? -45 : 0,
      }}
    />
  );
};
export default PlainLineSmall;
